export default "__VITE_ASSET__DtSrz1WE__"